import { Record } from 'immutable';
export default Record({
  password: null,
  user: null
});